import 'styles/appContainer.scss';
import 'helpers/tweaks';

import * as ReactDOM from 'react-dom';
import bootstrap from 'bootstrap.jsx';

const rootEl = document.getElementById('app');
const app = bootstrap();
ReactDOM.render(app, rootEl);